import { render } from "./PawnPromotionPopup.vue?vue&type=template&id=4885e2d6&scoped=true"
import script from "./PawnPromotionPopup.vue?vue&type=script&lang=js"
export * from "./PawnPromotionPopup.vue?vue&type=script&lang=js"

import "./PawnPromotionPopup.vue?vue&type=style&index=0&id=4885e2d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4885e2d6"]])

export default __exports__